import React, {useState} from "react";
import _ from "lodash";
import RenderFields from "../../../common/ui/render-fields";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {PROMPT_INPUT_FIELDS} from "../../constants/prompt.constant";
import {addSinglePrompt, updateSinglePrompt} from "../../services/prompt-data-service";

const AddEditPrompt = ({selectedPrompt = {}, refreshPromptList, isAddPrompt = false, isEditPrompt = false}) => {
    const [showModal, setShowModal] = useState(false);
    const [prompt, setPrompt] = useState(selectedPrompt);
    const [saveInProgress, setSaveInProgress] = useState(false);

    const handleConfirmAction = async () => {
        setSaveInProgress(true);

        const existingPrompt = {...prompt};

        if (isEditPrompt) {
            await updateSinglePrompt(existingPrompt);
        } else {
            await addSinglePrompt(existingPrompt);
        }

        setSaveInProgress(false);
        refreshPromptList();
        setShowModal(false);
    }

    const handlePromptChanges = (event) => {
        const {name, value, type} = event.target;
        const existingPrompt = {...prompt};

        if (type === 'checkbox') {
            existingPrompt[name] = !existingPrompt[name];
        } else if (type === 'number') {
            existingPrompt[name] = _.parseInt(value);
        } else {
            existingPrompt[name] = value;
        }

        preparePromptDetail(existingPrompt);
        setPrompt(existingPrompt);
    }

    const preparePromptDetail = (existingPrompt) => {
        _.forEach(PROMPT_INPUT_FIELDS, (field: any) => {
            if (!_.isEmpty(field.default) && _.isEmpty(existingPrompt[field.attribute])) {
                existingPrompt[field.attribute] = field?.default || '';
            }
        });
    }

    return (
        <>
            {isAddPrompt &&
                <button
                    className="button-green px-3 py-2"
                    onClick={() => setShowModal(true)}>
                    Add Prompt
                </button>
            }

            {isEditPrompt &&
                <button
                    className="button-outline-green px-3 py-2"
                    onClick={() => setShowModal(true)}>
                    Edit
                </button>
            }

            {showModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-1/2 my-6 mx-auto max-w-3xl">
                            {/*content*/}
                            <div
                                className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-gray-100 outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex items-start justify-between p-5 border-b border-solid rounded-t">
                                    <h3 className="text-lg font-semibold">
                                        {isAddPrompt &&
                                            <>Add Prompt</>
                                        }

                                        {isEditPrompt &&
                                            <>Edit Prompt</>
                                        }
                                    </h3>
                                    <button
                                        className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                                        onClick={() => setShowModal(false)}>
                                            <span
                                                className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                                              ×</span>
                                    </button>
                                </div>
                                {/*body*/}
                                <div className="relative p-5 flex-auto">
                                    <div className="leading-relaxed">
                                        <div className="flex flex-wrap justify-start">
                                            <RenderFields
                                                parentForm={prompt}
                                                handleDetailChanges={handlePromptChanges}
                                                fieldList={_.groupBy(PROMPT_INPUT_FIELDS, 'group')['prompt']}
                                                enableEdit={true}
                                                fieldClassName={'w-full'}/>
                                        </div>

                                        <div className="flex flex-wrap justify-start">
                                            <RenderFields
                                                parentForm={prompt}
                                                handleDetailChanges={handlePromptChanges}
                                                fieldList={_.groupBy(PROMPT_INPUT_FIELDS, 'group')['filter']}
                                                enableEdit={true}
                                                fieldClassName={'w-1/3'}/>
                                        </div>
                                    </div>
                                </div>
                                {/*footer*/}
                                <div
                                    className="flex items-center justify-end p-5 border-t border-solid border-blueGray-200 rounded-b">
                                    <div className="ml-4 -mt-1">
                                        <ShowProgressSpinner dataFetchInProgress={saveInProgress}/>
                                    </div>
                                    <button
                                        className="ml-2 text-gray-500 font-bold border border-gray-500 h-10 rounded px-4 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={() => setShowModal(false)}>
                                        Cancel
                                    </button>
                                    <button
                                        className="ml-2 bg-green-500 text-white active:bg-green-600 h-10 rounded px-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleConfirmAction}>
                                        Confirm Prompt
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}

export default AddEditPrompt
